import CheckSubmitClaim from 'components/CheckSubmitClaim/CheckSubmit.component';

const CheckSubmitClaims = () => {
	return <CheckSubmitClaim />;
};

export default CheckSubmitClaims;
